const ResponseCode = {
  BAD_REQUEST: {
    code: 400,
    message: "Parametros enviados incorrectos."
  },
  NOT_FOUND: {
    code: 404,
    message: "Registro no encontrado."
  },
  CONNECTION_ERROR: {
    code: 600,
    message: "Error en la conexión de internet."
  },
  NETWORK_ERROR: {
    code: 503,
    message: "No se pudo comunicar con el servidor."
  },
  TIMEOUT_ERROR: {
    code: 504,
    message: "Ha excedido el tiempo de respuesta."
  },
  SERVER_ERROR: {
    code: 500,
    message:
      "En este momento no es posible establecer una comunicación con el servidor, favor intentar más tarde."
  },
  NO_DATA: {
    code: 501,
    message: "Aún no existen datos."
  },
  UNAUTHORIZED: {
    code: 401,
    message: "Unauthorized"
  },
  OK: {
    code: 200,
    message: "OK"
  },
  USER_AUTHENTICATED: {
    code: 10,
    message: "UserOK"
  },
  AUTHENTICATION_FAILED: {
    code: 12,
    message: "Usuario o contraseña incorrectos."
  },
  NO_DATA_FOUND: {
    code: 204,
    message: "No hay datos para mostrar."
  }
};

export default ResponseCode;
